import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DssReports } from '../../../models/dss-reports';
import { VerificationRequestData } from '../../../models/verification-request-data';
import { VerificationResponseData } from '../../../models/verification-response-data';
import { environment } from '../../../../environments/environment';
import { LogService } from '../../../modules/shared/services/log.service';

@Injectable()
export class VerificationService {

  basePisteUrl = environment.pisteBaseUrl;

  constructor(private http: HttpClient, private LOG: LogService) {
  }

  verify(request: VerificationRequestData): Observable<VerificationResponseData> {
    const formData = new FormData();
    request.reportType = 'ALL';
    formData.append('reportType', request.reportType);
    formData.append('originalFiles', request.originalFile);
    formData.append('signedDocument', request.signedDocument);
    this.LOG.log('[RQ][reportType] : {0}', request.reportType);
    if (request.originalFile) {
      this.LOG.log('[RQ][originalFile] : {0}', request.originalFile.name);
    }
    if (request.signedDocument) {
      this.LOG.log('[RQ][signedDocument] : {0}', request.signedDocument.name);
    }
    return this.http.post<VerificationResponseData>(this.basePisteUrl + '/verify', formData, {withCredentials: true });
  }

  policy(): Observable<VerificationResponseData> {
    return this.http.get<VerificationResponseData>(this.basePisteUrl + '/policy');
  }

  dssReports(id: string): Observable<DssReports> {
    let params = new HttpParams();
    params = params.append('reportID', id);
    return this.http.get<DssReports>(this.basePisteUrl + '/dssReports', { params });
  }
}
